const UtilObject = {
  isEmpty: (obj) => {
    return !obj || Object.keys(obj).length === 0;
  },
  isObject: (item) => {
    return item && typeof item === 'object' && !Array.isArray(item);
  },
  EMPTY_OBJECT: {},
};

export default UtilObject;
